export default __webpack_public_path__ + "static/media/logo-tab-templates.e4cede99.svg";